module.exports = __webpack_public_path__ + "static/media/N. Lenore, Willits, CA (2 Buildings)8.5007c342.jpg";